// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeletedByMe__text-c56139 {
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 100px;
  background-color: var(--additional-150);
  color: var(--base-70);
  font: var(--font-body-5);
  padding-bottom: 8px;
}

.DeletedByMe__icon-b6a872 {
  fill: var(--base-70);
  min-width: min-content;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/DeletedByMe/DeletedByMePayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,uCAAA;EACA,qBAAA;EACA,wBAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,sBAAA;AACF","sourcesContent":[".text {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 100px;\n  background-color: var(--additional-150);\n  color: var(--base-70);\n  font: var(--font-body-5);\n  padding-bottom: 8px;\n}\n\n.icon {\n  fill: var(--base-70);\n  min-width: min-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `DeletedByMe__text-c56139`,
	"icon": `DeletedByMe__icon-b6a872`
};
module.exports = ___CSS_LOADER_EXPORT___;
